import type { Me } from '../api';
import styles from '../styles/app.module.css';
import { TEXT } from '../texts';

interface ProjectSelectProps {
  projects: Me['projects'];
  /** Empty when no project is chosen yet. */
  value: string;
  onChange: (projectId: string) => void;
  /** Visible caption above the dropdown; without it the dropdown is labelled for screen readers only. */
  label?: string;
}

/** Only lists the customers of the person's session; the gateway enforces access on every request. */
export function ProjectSelect({ projects, value, onChange, label }: ProjectSelectProps): React.JSX.Element {
  const select = (
    <select
      className={styles.projectSelect}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      {...(label === undefined ? { 'aria-label': TEXT.chooseProject } : {})}
    >
      {value === '' ? (
        <option value="" disabled>
          {TEXT.chooseProject}
        </option>
      ) : null}
      {projects.map((project) => (
        <option key={project.id} value={project.id}>
          {project.name}
        </option>
      ))}
    </select>
  );
  if (label === undefined) return select;
  return (
    <label className={styles.field}>
      {label}
      {select}
    </label>
  );
}
